import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from 'react';
import '../../styles/game/InfoBoard.css';
import '../../styles/game/InfoBoardTabs.css';
import HugeWins from './infoboard_components/HugeWins.jsx';
import BiggestWins from './infoboard_components/BiggestWins.jsx';
import Multipliers from './infoboard_components/Multipliers.jsx';
import { t } from "i18next";
import { useAuth } from '../../providers/AuthProvider.jsx';
function Top() {
    const { user } = useAuth()
    const [mainWallet, setMainWallet] = useState('uzs')
    const [isHugeWins, setIsHugeWins] = useState(true);
    const [isBiggest, setIsBiggest] = useState(false);
    const [isMultipliers, setIsMultipliers] = useState(false);
    const [isDay, setIsDay] = useState(true);
    const [isMonth, setIsMonth] = useState(false);
    const [isYear, setIsYear] = useState(false);

    useEffect(() => {
        if(user) {
          setMainWallet(user.mainWallet)
        }
      }, [user])

    const handleNavClick = (tab) => {
        setIsHugeWins(tab === "huge");
        setIsBiggest(tab === "biggest");
        setIsMultipliers(tab === "multi");
    };

    const handlePeriod = (tab) => {
        setIsDay(tab === "day");
        setIsMonth(tab === "month");
        setIsYear(tab === "year");
    };


    return (
        <>
            <div className={'top-tab-wrapper'}>
                <div className={'top-opt-wrapper'}>
                    <div className={'top-opt'} style={{"marginBottom": "4px"}}>
                        <button className={`top-opt-buttons ${isHugeWins ? "active" : ""}`} onClick={() => handleNavClick("huge")}>X</button>
                        <button className={`top-opt-buttons ${isBiggest ? "active" : ""}`} onClick={() => handleNavClick("biggest")}>{t("win")}</button>
                        <button className={`top-opt-buttons ${isMultipliers ? "active" : ""}`} onClick={() => {handleNavClick("multi")}}>{t("rounds")}</button>
                    </div>
                    <div className={'top-opt'}>
                        <button className={`top-opt-buttons ${isDay ? "active" : ""}`} onClick={() => handlePeriod("day")}>{t("Day")}</button>
                        <button className={`top-opt-buttons ${isMonth ? "active" : ""}`} onClick={() => handlePeriod("month")}>{t("Month")}</button>
                        <button className={`top-opt-buttons ${isYear ? "active" : ""}`} onClick={() => {handlePeriod("year")}}>{t("Year")}</button>
                    </div>
                    
                </div>
                {isHugeWins && <HugeWins isDay={isDay} setIsDay={setIsDay} isMonth={isMonth} setIsMonth={setIsMonth} isYear={isYear} setIsYear={setIsYear} mainWallet={mainWallet} />}
                {isBiggest && <BiggestWins isDay={isDay} setIsDay={setIsDay} isMonth={isMonth} setIsMonth={setIsMonth} isYear={isYear} setIsYear={setIsYear} mainWallet={mainWallet} />}
                {isMultipliers && <Multipliers isDay={isDay} setIsDay={setIsDay} isMonth={isMonth} setIsMonth={setIsMonth} isYear={isYear} setIsYear={setIsYear} mainWallet={mainWallet} />}
            </div>
        </>
    )
}

export default Top;